import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "children"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import useMergedRefs from 'hooks/useMergedRefs';
import { usePageTitleAnnouncer } from './PageTitleAnnouncer';
import { useSetDocumentTitle } from './DocumentTitleProvider';
import Heading from 'components/Heading';

// We need to type-cast Heading to a simpler version of itself as TS
// will otherwise be overwhelmed by the polymorphism complexity :(
// "Expression produces a union type that is too complex to represent."

var StyledHeading = styled(Heading).withConfig({
  displayName: "PageTitle__StyledHeading",
  componentId: "sc-13rgblv-0"
})(["&:focus{outline:none;}"]);
var PageTitle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var text = _ref.text,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var areChildrenText = typeof children === 'string';
  var pageTitle = text || (areChildrenText ? children : '');
  var pageTitleRef = usePageTitleAnnouncer(pageTitle);
  var mergedRefs = useMergedRefs([ref, pageTitleRef]);
  useSetDocumentTitle(pageTitle);
  if (!areChildrenText && text === undefined) {
    // eslint-disable-next-line no-console
    console.warn('PageTitle: Type of the "children" prop is not string. Please provide a string-only label to the PageTitle component via the "text" prop.', children);
  }
  return /*#__PURE__*/React.createElement(StyledHeading, _extends({}, otherProps, {
    forwardedAs: "h1",
    tabIndex: -1,
    ref: mergedRefs
  }), children);
});
PageTitle.displayName = 'PageTitle';
export default PageTitle;